import { styled } from "@mui/material";
import { useParentBg } from "../../shared";
import { useGetCurrentColor } from "./helpers";
import Box from "../Box";
import Typography from "../Typography";
const StyledChip = styled(Box)((props) => {
  const { size, color, variant, isOnlyIcon, theme } = props;
  const chip = theme.chip;
  const parentBg = useParentBg();
  const { backgroundColor, textColor } = useGetCurrentColor(
    variant,
    color,
    parentBg
  );
  const paddingHorizontal = isOnlyIcon ? chip.spacing.horizontal.onlyIcon[size] : chip.spacing.horizontal.default[size];
  return {
    display: "flex",
    alignItems: "center",
    height: chip.size[size],
    borderRadius: chip.borderRadius[size],
    background: backgroundColor,
    color: textColor,
    paddingLeft: paddingHorizontal,
    paddingRight: paddingHorizontal,
    gap: chip.spacing.gap[size]
  };
});
const StyledTypography = styled(Typography)(() => ({
  whiteSpace: "nowrap"
}));
export {
  StyledChip,
  StyledTypography
};
